<template>
    <div
        class="dropdown c-settings-select"
        :class="{ show: active }"
    >
        <span class="d-md-none d-lg-inline-block">{{ text }}</span>
        <button
            @click.stop="active = !active"
            class="btn btn-text text-primary p-0"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <template v-if="perPage">{{ perPage }}</template>
            <template v-else>{{ options[0] }}</template>
            <a-icon icon="Dropdown" />
        </button>
        <div
            v-click-outside="closeDropdown"
            v-if="active"
            class="dropdown-menu dropdown-menu-right"
            :class="{ show: active }"
        >
            <button
                @click="
                    active = !active
                    selectOption(option)
                "
                class="dropdown-item"
                type="button"
                v-for="(option, id) in options"
                :key="id"
            >
                {{ option }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: false
        }
    },
    props: {
        text: {
            type: String,
            required: true
        },
        onChange: {
            type: Function
        },
        perPage: {
            type: Number,
            required: false
        },
        options: {
            type: Array,
            default: () => [10, 25, 50]
        }
    },
    methods: {
        selectOption(option) {
            this.onChange(option)
        },
        closeDropdown() {
            this.active = !this.active
        }
    }
}
</script>
